import { useState, ChangeEvent, Dispatch, SetStateAction } from 'react'
import TextField from '@mui/material/TextField'
import {
  usePlacesService,
  PlacePrediction,
} from '../../../../utils/places-api-client'
import styles from './styles.module.css'
import { fetchData } from '../../../../global/utils/fetch'
import { getZipCodeAvailability } from '../../../../schedule/components/api'
import { geocodeStringAddress } from './api'
import { GeocodedAddress } from '../../../../../../app/types/scheduling'

interface IGoogleAddressSearchBarProps {
  addressInput: string
  setAddressInput: Dispatch<SetStateAction<string>>
  setIsZipCodeServiced: Dispatch<SetStateAction<boolean | undefined>>
  setFormattedAddress: Function
}

export default function GoogleAddressSearchBar({
  addressInput,
  setAddressInput,
  setIsZipCodeServiced,
  setFormattedAddress,
}: IGoogleAddressSearchBarProps) {
  const [hasChosenAddress, setHasChosenAddress] = useState(false)

  const { placePredictions, getPlacePredictions, isPlacePredictionsLoading } =
    usePlacesService({
      apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
      options: {
        input: addressInput,
        types: ['address'],
        componentRestrictions: {
          country: 'us',
        },
      },
    })

  async function handlePredictionClick(address: PlacePrediction) {
    setHasChosenAddress(true)
    setAddressInput(address.description)
    getPlacePredictions({
      input: '',
    })

    const geocodedAddress = await fetchData<GeocodedAddress>(
      geocodeStringAddress(address.description),
    )

    if (!geocodedAddress.address) return alert('No address found, try again')

    const typedAddress = geocodedAddress.address

    const isServiced = await fetchData<any>(
      getZipCodeAvailability(typedAddress?.zipCode),
    )

    if (isServiced.serviced) {
      setFormattedAddress(typedAddress)
    } else {
      setFormattedAddress({
        address: '',
        city: '',
        state: '',
        zipCode: '',
      })
    }
    setIsZipCodeServiced(isServiced.serviced)
  }

  async function addressHandler(event: ChangeEvent<HTMLInputElement>) {
    setHasChosenAddress(false)
    setIsZipCodeServiced(undefined)
    const addressValue = event.target.value

    setAddressInput(addressValue)

    getPlacePredictions({
      input: addressValue,
    })
  }

  return (
    <div className={styles.addressContainer}>
      <div>
        <TextField
          name='address'
          label={'Address'}
          onChange={addressHandler}
          value={addressInput}
          autoComplete='off'
          style={{ width: '400px' }}
        />
        <div
          className={styles.addressResultsHolder}
          style={{ display: placePredictions?.length > 0 ? 'block' : 'none' }}
        >
          {isPlacePredictionsLoading ? (
            <div className={styles.addressResult}>
              <i>Loading...</i>
            </div>
          ) : (
            placePredictions &&
            placePredictions.length > 0 &&
            !hasChosenAddress &&
            placePredictions.map((prediction: PlacePrediction, idx: number) => {
              return (
                <div
                  key={idx}
                  className={styles.addressResult}
                  onClick={() => handlePredictionClick(prediction)}
                >
                  <div className={styles.addressResultIcon} />
                  <div className={styles.addressResultDescription}>
                    {prediction.description}
                  </div>
                </div>
              )
            })
          )}
        </div>
      </div>
    </div>
  )
}
